
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
// Import i18n after React to ensure React is available for hooks
import './i18n';
import App from './App.tsx';

// Implement global error handler for module loading issues
window.addEventListener('error', (event) => {
  if (event.message.includes('Failed to fetch dynamically imported module')) {
    console.error('Module loading error detected:', event);
    // Log additional information for debugging
    console.log('User agent:', navigator.userAgent);
    console.log('URL:', window.location.href);
    
    // Clear browser cache for this specific resource if possible
    if (event.filename) {
      console.log('Attempting to fetch problematic resource directly:', event.filename);
      fetch(event.filename, { cache: 'reload' })
        .then(res => console.log('Resource fetch attempt result:', res.status))
        .catch(err => console.error('Direct fetch failed:', err));
    }
  }
});

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered with scope:', registration.scope);
        // Update service worker to ensure we have the latest version
        registration.update();
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}

console.log('PWA initialization check: serviceWorker support = ', 'serviceWorker' in navigator);

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
